"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntermediateThrowEvent = void 0;
const Constants_1 = require("../Constants");
const EventBase_1 = require("./EventBase");
/**
 * Describes a BPMN IntermediateThrowEvent.
 *
 * These are used to raise events during ProcessModel execution.
 */
class IntermediateThrowEvent extends EventBase_1.Event {
    get bpmnType() {
        return Constants_1.BpmnType.intermediateThrowEvent;
    }
    get eventType() {
        const eventIsMessageEvent = this.messageEventDefinition !== undefined;
        if (eventIsMessageEvent) {
            return Constants_1.EventType.messageEvent;
        }
        const eventIsSignalEvent = this.signalEventDefinition !== undefined;
        if (eventIsSignalEvent) {
            return Constants_1.EventType.signalEvent;
        }
        const eventIsLinkEvent = this.linkEventDefinition !== undefined;
        if (eventIsLinkEvent) {
            return Constants_1.EventType.linkEvent;
        }
        return undefined;
    }
}
exports.IntermediateThrowEvent = IntermediateThrowEvent;
//# sourceMappingURL=IntermediateThrowEvent.js.map